export default __webpack_public_path__ + "static/imda20183rdprize2-0f6f716193b2b10678bf080faf6564e1.jpg";